var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('img',{attrs:{"src":require("@/assets/images/logo_small.png"),"width":"105px"},on:{"click":_vm.register}}),_c('div',{staticClass:"title"},[_c('span',[_c('router-link',{staticClass:"home",attrs:{"to":"/"}},[_vm._v("Genome-wide summary statistics")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }